var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDnsTemplating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 82,
    viewBox: "0 0 216 82",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.5 18A38.825 38.825 0 0 0 70 41c0 21.54 17.46 39 39 39s39-17.46 39-39-17.46-39-39-39C96.196 2 84.834 8.17 77.723 17.699c-3.8-.95-6.585-4.037-6.585-7.699 0-4.418 4.053-8 9.054-8h126.754c5 0 9.054 3.582 9.054 8s-4.054 8-9.054 8H155.21c5 0 9.053 3.582 9.053 8s-4.053 8-9.053 8h28.455c5 0 9.054 3.582 9.054 8s-4.054 8-9.054 8h-13.16c-6.304 0-11.415 3.582-11.415 8 0 2.946 2.587 5.612 7.76 8 5 0 9.054 3.582 9.054 8s-4.053 8-9.054 8H59.497c-5 0-9.054-3.582-9.054-8s4.054-8 9.054-8H9.054C4.054 66 0 62.418 0 58s4.054-8 9.054-8H60.79c5 0 9.054-3.582 9.054-8s-4.053-8-9.054-8H28.455c-5 0-9.054-3.582-9.054-8s4.054-8 9.054-8h49.046Zm129.446 32c-5 0-9.054-3.582-9.054-8s4.054-8 9.054-8S216 37.582 216 42s-4.054 8-9.054 8Z",
    fillOpacity: 0.3,
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 39,
    r: 39,
    transform: "translate(70 2)",
    stroke: "#6A6666",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92 76.097V17a2 2 0 0 1 2-2h43.678",
    stroke: "#6A6666",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.146 28.037h-.002a1 1 0 0 0-1.016.983l-.095 5.743a1 1 0 0 0 .981 1.016l5.228.097h.002a1 1 0 0 0 1.016-.984l.095-5.743a1 1 0 0 0-.981-1.016l-5.228-.096ZM101.146 46.949h-.002a1 1 0 0 0-1.016.983l-.095 5.743a1 1 0 0 0 .981 1.016l5.228.097h.002a1 1 0 0 0 1.016-.983l.095-5.743a1 1 0 0 0-.981-1.017l-5.228-.096ZM101.146 65.861h-.002a1 1 0 0 0-1.016.984l-.095 5.742a1 1 0 0 0 .981 1.017l5.228.096h.002a1 1 0 0 0 1.016-.983l.095-5.743a1 1 0 0 0-.981-1.016l-5.228-.097Z",
    stroke: "#6A6666",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 32.5h18-18Zm1 17.122h31-31Zm0 19h20-20Z",
    stroke: "#6A6666",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDnsTemplating);
export default __webpack_public_path__ + "static/media/dns-templating.4cc4efd52bd9c41ce99f9666f4222e0c.svg";
export { ForwardRef as ReactComponent };